import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationProgressBar } from './core/layout/navigation-progress-bar/navigation-progress-bar';

@Component({
  selector: 'jp-root',
  imports: [RouterOutlet, NavigationProgressBar],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
}
